import React from 'react';

function TrunkIp(props) {
  const { changeValues, tenants } = props;
  /*
    IP:
      {
        "provider": "Embratel",
        "ipSbcTrunk": "172.23.25.100",
        "ipLocal": "200.201.11.12",
        "trunkNumber": "1432230303",
        "codec": "alaw",
        "authUsername": "",
        "password": "",
        "type": "IP"
      }
  */

  return (
    <div>
      <div className="columns mx-2">
        <div className="column is-3 field">
          <label className="label">Operadora
            <div className="control">
              <input className="input" name="provider" type="text" onChange={(e) => changeValues(e.target)} placeholder="Nome" />
              <p name="provider-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Tronco
            <div className="control">
              <input className="input" name="trunkNumber" type="text" onChange={(e) => changeValues(e.target)} placeholder="1431110000" />
              <p name="trunkNumber-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-3 field">
          <label className="label">Cliente
            <div className="control">
              <div name="tenant" className="select is-fullwidth">
                <select className="select" name="tenant" onChange={(e) => changeValues(e.target)} >
                  <option value=""> Selecione </option>
                  { tenants.map((tenant) => <option key={`${tenant.short_name}`} value={tenant.short_name}>{ tenant.name }</option>) }
                </select>
              </div>
            </div>
          </label>
        </div>
        <div className="column is-2 pl-5 field">
          <div className="columns mt-1"><b>Codec</b>
            <div className="column is-multiline">
              <div className="is-fullwidth"> ALAW <br/>
                  <input className='ml-3' name="codec" type="checkbox" value="alaw" onChange={ (e) => changeValues(e.target)}/>
              </div>
            </div>
            <div className="column is-multiline is-centered">
              <div className="is-fullwidth"> ULAW <br/>
                  <input className='ml-3' name="codec" type="checkbox" value="ulaw" onChange={ (e) => changeValues(e.target)}/>
              </div>
            </div>
            <div className="column is-multiline is-centered">
              <div className="is-fullwidth"> G.729 <br/>
                  <input className='ml-3' name="codec" type="checkbox" value="g729" onChange={ (e) => changeValues(e.target)}/>
              </div>
            </div>
            <div className="column is-multiline is-centered">
              <div className="is-fullwidth"> H.264 <br/>
                  <input className='ml-3' name="codec" type="checkbox" value="h264" onChange={ (e) => changeValues(e.target)}/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="columns mx-2">
        <div className="column is-4 field">
          <label className="label">IP SIP (Operadora)
            <div className="control">
              <input className="input" name="ipSbcTrunk" type="text" onBlur={(e) => changeValues(e.target)} placeholder="1.0.0.1" />
              <p name="ipSbcTrunk-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-4 field">
          <label className="label">IP Local (Central)
            <div className="control">
              <input className="input" name="ipLocal" type="text" onBlur={(e) => changeValues(e.target)} placeholder="2.0.0.1" />
              <p name="ipLocal-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-4 field">
          <label className="label">Modo 
            <div className="control">
              <div name="mode" className="select is-fullwidth">
                <select className="select" name="mode" onChange={(e) => changeValues(e.target)} >
                  <option value=""> Selecione </option>
                  <option value="bidirecional"> Bidirecional </option>
                  <option value="unidirecional"> Unidirecional </option>
                </select>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
}

export default TrunkIp;
